/**
 * Contenu éditorial réellement spécifique à chaque ville, pour les services
 * « DJ anniversaire » et « DJ soirée d'entreprise ».
 *
 * Seules les villes présentes dans ces dictionnaires sont indexables :
 * les autres villes gardent une page accessible aux visiteurs et au maillage
 * interne, mais passent en `noindex,follow` et sortent du sitemap
 * (règle Google sur les doorway pages / contenu dupliqué).
 */

export type CityServiceSection = {
  h2: string;
  paragraphs: string[];
};

export type CityServiceContent = {
  /** Paragraphe d'accroche du hero — propre à la ville. */
  intro: string;
  /** Distance et temps de trajet réels depuis Cavaillon (base de DJ Val). */
  logistics: {
    distance: string;
    duration: string;
    route: string;
    note: string;
  };
  /** Salles, domaines et lieux nommés de la ville. */
  venues: { name: string; text: string }[];
  /** Contraintes locales : horaires, accès, nuisances sonores. */
  constraints: string[];
  /** Exemple concret de prestation déjà réalisée dans la ville. */
  caseStudy: { title: string; text: string };
  /** Corps de page — 2 à 3 sections rédigées, propres à la ville. */
  sections: CityServiceSection[];
  /** FAQ spécifique à la ville. */
  faq: { q: string; a: string }[];
};

/** Villes gardées en version indexable pour les services satellites. */
export const INDEXABLE_SERVICE_CITIES = [
  "avignon",
  "cavaillon",
  "aix-en-provence",
  "arles",
  "carpentras",
  "saint-remy",
] as const;
